import { render } from "react-dom";
import React from "react";
import Favoritos from "../components/favoritos.jsx";
import AjaxError from "./ajaxError.js";
const favorites = {
	migrate: function() {
		if (typeof Cookies.getJSON("games_favorites") != "undefined") {
			localStorage.setItem(
				"games_favorites",
				JSON.stringify(Cookies.getJSON("games_favorites"))
			);
			Cookies.remove("games_favorites");
		}
	},
	load: function() {
		window.favorites = JSON.parse(localStorage.getItem("games_favorites"));
		if (window.favorites === null) {
			window.favorites = [];
		}
	},
	toggler: function(id) {
		$.ajax({
			url: links.api.favorite
				.replace("_SK_", window.session_key)
				.replace("_ID_", id),
			cache: false
		})
			.done(function() {})
			.fail(AjaxError);
		if (!favorites.isFavorited(id)) {
			window.favorites = $.grep(window.favorites, function(e) {
				return e.id != id;
			});
			window.favorites.unshift(gameSettings.gameInfo);
		} else {
			window.favorites = $.grep(window.favorites, function(e) {
				return e.id != id;
			});
		}
		localStorage.setItem("games_favorites", JSON.stringify(window.favorites));
		if (window.updateFavorites) {
			render(
				<Favoritos items={window.favorites} />,
				document.getElementById("FavoritosContainer")
			);
		}
	},

	isFavorited(id) {
		const favoritedGames = window.favorites || [];
		return favoritedGames.find(el => el.id === id) !== undefined;
	}
};
export default favorites;
